// extracted by mini-css-extract-plugin
module.exports =  {"upload-custom-font-btn":"upload-custom-font-btn--Os4_1","uploadCustomFontBtn":"upload-custom-font-btn--Os4_1"};